import { SimpleCsticId, type ConflictKmat, type Kmat, type LinearSubstep } from "../../Linear/models";
import { fromExtraValidationToDirtyParamName } from "../../Linear/utils";
import { getExtraValidationParamName } from "../../Linear/namingUtils";
import { csticHasValue } from "~/Configurators/common/v2/helper";

export function getConflictCsticNames(conflicts: ConflictKmat[]): string[] {
  return conflicts.flatMap((conflict) => conflict.cstics.map((cstic) => cstic.name));
}

export function validateFromDefinition(substep: LinearSubstep, mainKmat: Kmat, conflicts: ConflictKmat[]) {
  const conflictedCstics = getConflictCsticNames(conflicts);

  let valid = true;
  const extraValidations: Record<string, boolean> = {};
  const additionalData: Record<string, boolean> = {};

  if (!substep.isVisible) {
    return {
      substepValid: true,
      extraValidations: {},
      additionalData: {},
    };
  }

  if (substep.tiles.length || substep.groupedTiles.length) {
    // Validate that a tile is selected
    valid = substep.selectedTile !== null;
  }
  Object.values(substep.inputCstics).forEach((cstic) => {
    let csticValid = true;

    if (cstic.visible) {
      csticValid = !conflictedCstics.includes(cstic.name);
    }

    if (cstic.visible && cstic.required) {
      csticValid = csticValid && csticHasValue(mainKmat, cstic.name);
    }
    valid = valid && csticValid;
    const key = getExtraValidationParamName(SimpleCsticId(cstic.name));
    extraValidations[key] = csticValid;
    const dirtyKey = fromExtraValidationToDirtyParamName(key);
    additionalData[dirtyKey] = true;
  });

  return {
    substepValid: valid,
    extraValidations,
    additionalData,
  };
}
